<template>
    <div>
        <div class="innerMainContent">
            <div class="innerHeader">
                <div class="h1Wrap">
                    <svg class="i_profile"><use xlink:href="#i_profile"></use></svg>
                    <div class="innerH1Wrap">
                        <h1>{{ $t('presetEdit') }}</h1>
                        <ul class="breadcrumb">
                            <li><router-link to="/">{{ $t('menu_hp') }}</router-link></li>
                            <li><router-link to="/settings">{{ $t('menu_settings') }}</router-link></li>
                            <li><router-link to="/settings/presets">{{ $t('presets') }}</router-link></li>
                            <li class="active">{{ $t('presetEdit') }}</li>
                        </ul>
                    </div>
                </div>
                <div class="editEventActions">
                    <router-link tag="button" class="backBtn" to="/settings/presets">
                        <span>{{ $t('back') }}</span>
                        <svg class="i_back"><use xlink:href="#i_longArr"></use></svg>
                    </router-link>
                </div>
            </div>
            <div class="innerBox">
                <form action="" id="editPreset" class="formWrap" @submit.prevent="submitForm">
                    <div class="row">
                        <div class="col-xs-12 containerWidth">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="inputWrap">
                                        <label for="name">*{{ $t('preset_name') }}</label>
                                        <input type="text" id="name" name="name" v-model="preset.name" required>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="inputWrap">
                                        <label for="target">*{{ $t('hall') }}</label>
                                        <div class="selectWrap">
                                            <select name="target" id="target" v-model="preset.hall.id" required>
                                                <option value="">{{ $t('select') }}</option>
                                                <option v-for="hall in this.$store.state.halls" v-bind:value="hall.id" v-bind:selected="hall.id == preset.hall.id ? 'selected' : ''">{{ hall.name }}</option>
                                            </select>
                                            <svg class="i_select"><use xlink:href="#i_select"></use></svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="inputWrap">
                                        <label for="capacity">*{{ $t('capacity') }}</label>
                                        <input type="number" id="capacity" name="capacity" v-model="preset.capacity" required>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <FileUpload v-on:uploaded="setFile" :label="'preset_background'" :placeHolder="'addFile'"></FileUpload>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="inputWrap submitWrap">
                                        <button class="submit">{{ $t('save') }}</button>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>

                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import FileUpload from '../Common/FileUpload'
    export default {
        name: 'EditPreset',
        data() {
            return {
                preset:{
                    id:'',
                    name:'',
                    capacity:0,
                    hall:{id:''},
                    background:'',
                },
            }
        },
        components:{
            FileUpload
        },
        beforeMount(){
            //check permissions
            if(this.$store.state.user.type != 2){
                this.$router.push('/');
            }

            //get banner
            this.$data.preset.id = this.$router.currentRoute.params.id;
            this.$store.dispatch('getPreset',this.$data.preset.id)
                .then(response =>{
                    //success
                    delete response.background;
                    this.$data.preset = response;
                })
                .catch(err => {
                    //err
                    this.$router.push('/settings/presets');
                })

        },
        methods:{
            setFile(_){
                this.$data.preset.background = _;
            },
            submitForm(){
                this.$store.dispatch('updatePreset',this.$data.preset)
                    .then(response => {
                        this.$swal({
                            confirmButtonText:this.$t('okButton'),
                            type:'success',
                            title:this.$t('presetEdited'),
                            timer:2000
                        })
                            .then(preset =>{
                                this.$router.push('/settings/presets/' + response.id);
                            })
                            .catch(this.$swal.noop);
                    })
                    .catch(response => {
                        let err = this.$t('fatalError');

                        this.$swal({
                            confirmButtonText:this.$t('okButton'),
                            type:'error',
                            title:err,
                            timer:3000
                        }).catch(this.$swal.noop);
                    })
            }
        }
    }

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .innerMainContent{
        padding:55px 45px;
        float: right;
        width:100%;
    }

    .editEventActions{
        float:left;
        margin-top: 6px;
    }
    .editEventActions .backBtn span{
        color:#7c97c5;
        font-weight:700;
        font-size:1.235rem;
        display:inline-block;
        vertical-align:middle;
    }
    .editEventActions .backBtn svg{
        display:inline-block;
        vertical-align:middle;
        width:26px;
        height:18px;
        fill:#293b5a;
        margin-right:5px;
    }
    .editEventActions .deleteBtn{
        width:218px;
        height:54px;
        background: #fff;
        border:1px solid #d4d4d4;
        border-radius:27px;
        margin-left:30px;

    }
    .editEventActions .deleteBtn span{
        color:#293b5a;
        font-weight:700;
        font-size:1rem;
        display:inline-block;
        vertical-align:middle;
    }
    .editEventActions .deleteBtn svg{
        display:inline-block;
        vertical-align:middle;
        width:19px;
        height:23px;
        fill:#849dc8;
        margin-left:10px;
    }
    .innerBox{
        padding:30px;
    }
    .h1Wrap svg.i_profile{
        width:26px;
        height:30px;
    }
</style>
